/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

@Component({
    selector: 'app-drag-n-drop-table',
    templateUrl: './drag-n-drop-table.component.html',
    styleUrls: ['./drag-n-drop-table.component.scss']
})
export class DragNDropTableComponent {
    /**
     * Set the table rows.
     * @param rows
     */
    @Input() set tableRows(rows: any[]) {
        this._tableRows = rows;
        if (this.type) {
            this.setUpTable();
        }
    }

    /**
     * Store the type of table.
     */
    @Input() set type(type: 'acl' | 'headers') {
        this._type = type;
    }

    /**
     * Store the action dots template.
     */
    @Input() public actionDotsTemplate: TemplateRef<any>;

    /**
     * Allow parent component to disable the drag n drop functions.
     */
    @Input() set isDisabled(state: boolean) {
        this._isDisabled = state;
    }

    /**
     * HeaderIds out.
     */
    @Output() public orderedRows: EventEmitter<any> = new EventEmitter<any>();

    /**
     * Store the table headers with the visually friendy properties.
     */
    public tableHeaders: string[] = [];

    /**
     * Store the table headers with the raw properties.
     */
    public rawTableHeaders: string[] = [];

    /**
     * Setter/getter variable for table rows.
     * @private
     */
    private _tableRows: any[];

    /**
     * Setter/getter variable for page type.
     * @private
     */
    private _type: 'acl' | 'headers';

    /**
     * isDisabled private variable.
     * @private
     */
    private _isDisabled: boolean = false;

    constructor() {
    }

    get tableRows() {
        return this._tableRows;
    }

    get type() {
        return this._type;
    }

    get isDisabled() {
        return this._isDisabled;
    }

    /**
     * Get updated drop zone.
     * @param $event
     */
    public updateSelected($event: any): void {
        this.orderedRows.emit($event);
    }

    /**
     * Set up the table.
     * @private
     */
    private setUpTable(): void {
        this.setTableHeadersFromType();
    }

    /**
     * Set the table headers for the page.
     * @private
     */
    private setTableHeadersFromType(): void {
        switch (this.type) {
            case 'acl':
                this.rawTableHeaders = ['condition', 'type', 'redirectType', 'redirectLocation', 'redirectCode'];
                this.tableHeaders = ['Condition', 'Path Type', 'Redirect Type', 'Redirect Location', 'Redirect Code'];
                break;
            case 'headers':
                this.rawTableHeaders = ['type', 'option', 'name', 'value', 'replace'];
                this.tableHeaders = ['Type', 'Option', 'Name', 'Value', 'Replace Value'];
        }
    }
}
